import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=0987fad1&scoped=true&"
import script from "./Seating.vue?vue&type=script&lang=js&"
export * from "./Seating.vue?vue&type=script&lang=js&"
import style0 from "./Seating.vue?vue&type=style&index=0&id=0987fad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987fad1",
  null
  
)

export default component.exports